import { KeyValue } from '@angular/common';

/**
 * @param key = referral value that matches values in Quote's ReferralOptions.cs;
 * @param value = referral display name
 * @type { Array<KeyValue<number, string>> }
 */
export const REFERRAL_LIST: Array<KeyValue<number, string>> = [
	{ key: 0, value: 'Select an option' },
	{ key: 7, value: 'Banner Ad' },
	{ key: 4, value: 'Breeder' },
	{ key: 12, value: 'Cleveland Browns' },
	{ key: 2, value: 'Employer' },
	{ key: 11, value: 'Friend or Relative' },
	{ key: 1, value: 'Other' },
	{ key: 8, value: 'Podcast' },
	{ key: 3, value: 'Radio/Audio Ad' },
	{ key: 6, value: 'Rescue or Shelter' },
	{ key: 10, value: 'Social Media' },
	{ key: 5, value: 'TV Commercial/Video Ad' },
	{ key: 9, value: 'Vet Clinic' },
];

